/*@ngInject*/
const CommentsModalController = function ($rootScope, $scope, options, localization, coreConstant) {

    localization.getTranslations().then(function (root) {

        let translations = _.get(root, 'commentsModal');

        $scope.viewModel = {
            title: options.title ? options.title : _.get(translations, 'title'),
            summary: options.summary || options.summary === null ? options.summary : _.get(translations, 'summary'),
            label: options.label ? options.label : _.get(translations, 'label'),
            comments: options.comments,
            cancel: options.cancel ? options.cancel : _.get(translations, 'cancel'),
            primaryAction: options.primaryAction ? options.primaryAction : _.get(translations, 'primaryAction'),
            secondaryAction: options.secondaryAction ? options.secondaryAction : _.get(translations, 'secondaryAction'),
            showSecondaryAction: options.showSecondaryAction
        };

        $scope.onPrimaryAction = function () {
            $scope.$close({
                comments: $scope.viewModel.comments,
                primaryAction: true,
                secondaryAction: false
            });
        };

        $scope.onSecondaryAction = function () {
            $scope.$close({
                comments: $scope.viewModel.comments,
                primaryAction: false,
                secondaryAction: true
            });
        };
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('umFormViewer')
    .controller('commentsModalController', CommentsModalController);
